// Google Analytics 4 Integration for VestrioZ
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Measurement ID - Replace with your actual ID
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
  // Only initialize in production or when GA_MEASUREMENT_ID is set
  if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_GA_MEASUREMENT_ID) {
    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      page_title: 'VestrioZ - Rent or Sell Fashion & Jewellery',
      page_location: window.location.href,
      send_page_view: true
    });

  } else {
  }
};

// Track page views
export const trackPageView = (path, title) => {
  if (window.gtag && (process.env.NODE_ENV === 'production' || process.env.REACT_APP_GA_MEASUREMENT_ID)) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title || document.title,
      page_location: window.location.href
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (window.gtag && (process.env.NODE_ENV === 'production' || process.env.REACT_APP_GA_MEASUREMENT_ID)) {
    window.gtag('event', eventName, {
      event_category: parameters.category || 'engagement',
      event_label: parameters.label || '',
      value: parameters.value || 0,
      ...parameters
    });
  }
};

// Predefined event tracking functions
export const trackUserRegistration = (method = 'email') => {
  trackEvent('sign_up', {
    method: method,
    category: 'user_engagement'
  });
};

export const trackUserLogin = (method = 'email') => {
  trackEvent('login', {
    method: method,
    category: 'user_engagement'
  });
};

export const trackListingCreated = (itemType, category, price) => {
  trackEvent('create_listing', {
    category: 'user_action',
    item_type: itemType,
    item_category: category,
    value: parseFloat(price) || 0,
    currency: 'INR'
  });
};

export const trackListingViewed = (listingId, itemType, price) => {
  trackEvent('view_item', {
    category: 'engagement',
    item_id: listingId,
    item_type: itemType,
    value: parseFloat(price) || 0,
    currency: 'INR'
  });
};

export const trackChatStarted = (listingId) => {
  trackEvent('chat_started', {
    category: 'user_interaction',
    listing_id: listingId
  });
};

export const trackSearch = (searchTerm, category) => {
  trackEvent('search', {
    search_term: searchTerm,
    category: 'user_action',
    search_category: category || 'all'
  });
};

export const trackMembershipPurchase = (membershipType, amount) => {
  trackEvent('purchase', {
    transaction_id: Date.now().toString(),
    value: parseFloat(amount),
    currency: 'INR',
    category: 'ecommerce',
    item_name: `VestrioZ ${membershipType} Membership`
  });
};

// React hook for automatic page tracking
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const title = document.title;
    trackPageView(path, title);
  }, [location]);
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackUserRegistration,
  trackUserLogin,
  trackListingCreated,
  trackListingViewed,
  trackChatStarted,
  trackSearch,
  trackMembershipPurchase,
  usePageTracking
};